import { Component, Output, EventEmitter } from "@angular/core";

@Component({
    selector: 'app-debt-manager',
    templateUrl: './debt-manager.component.html',
    styleUrls: ['./debt-manager.component.scss'],
    standalone: false
})
export class DebtManagerComponent {
    @Output() onClickDebtManager: EventEmitter<null> = new EventEmitter();

    constructor() {}
}
